import type React from "react"

interface StepIndicatorProps {
  currentStep: number
  totalSteps?: number
  stepLabel: string
  completedSteps?: readonly number[]
}

const StepIndicator: React.FC<StepIndicatorProps> = ({
  currentStep,
  totalSteps = 7,
  stepLabel,
  completedSteps = [],
}) => (
  <div className="step-indicator">
    {Array.from({ length: totalSteps }, (_, index) => {
      const stepNumber = index + 1
      const isCompleted = completedSteps.includes(stepNumber) || stepNumber < currentStep
      const isActive = stepNumber === currentStep

      return (
        <div key={stepNumber}>
          <span className={`sync-step ${isCompleted ? "completed" : isActive ? "active" : ""}`}>
            {stepNumber}
          </span>
          {isActive && <span className="step-label">{stepLabel}</span>}
        </div>
      )
    })}
  </div>
)

export default StepIndicator
